import VueGtagPlugin from 'vue-gtag'
import getEnv from 'src/getEnv'

export default ({ router, Vue }) => {
  const enabled = process.env.NODE_ENV === 'production' && window.location.hostname === 'cms.juraganmaterial.id'

  Vue.use(
    VueGtagPlugin,
    {
      config: { id: getEnv('GTAG_ID') },
      enabled
    },
    router
  )
}
